import renderMathInElement from "katex/contrib/auto-render";
import { katexOptions } from "@/utilities";

window.renderMathInElement = renderMathInElement;

window.dodona.ready.then(() => {
    renderMathInElement(document.body, katexOptions);
});
